export const TEST_ID = {
  OVERVIEW_TAB_RESOURCES: 'bundle-detail__resources'
};